import { config } from '@/environment';

import { IsLocalHost } from '../helpers/isLocalHost';

const IS_LOCALHOST = IsLocalHost();

const APP_CONSTANTS = {
  IS_LOCALHOST,
  PATIENT_CASES_REPO_PATH: `${config.ASSETS_REPO}/patientCases/`,
  SHOW_CALL_BUTTONS: false,
  DISCLAIMER_TIMEOUT: {
    localhost: 2000,
    default: 6000,
  },
  SHOW_ANIMATIONS: !config.CYPRESS_SCREENSHOT && !config.DISABLE_ANIMATIONS,
};

export const NULL_ID_VALUE = 'NONE';
export const DEFAULT_HOST_VALUE = 'default';
export const DEFAULT_HOST_NAME = 'John Doe';

export const SYNCHRONISATION_CHECK_INTERVAL = 5000;

export default APP_CONSTANTS;

export const LOREAL_STATS_TUTORIAL_KEY = 'loreal_statsPage_tutorial_finished';
